export default __webpack_public_path__ + "static/media/pp-188.d7a01d6b.png";